import axios from 'axios'
import router from '@/router/index.js'
// import store from '@/store/index.js'
// 创建一个axios实例
var instance = axios.create({

    baseURL: "/",
})
// 请求拦截器
instance.interceptors.request.use(function (config) {

    // config.headers['E_Token'] = store.state.user.E_Token;
    return config;
}, function (error) {

    // 对请求错误做些什么
    return Promise.reject(error);
})
// 响应拦截
instance.interceptors.response.use(function (config) {

    if (config.data.retCode != 0) {

        // 处理后台异常
        return false;
    }
    return config;
}, function (error) {

    return Promise.reject(error)
})
export default function (method, url, data = null) {

    method = method.toLowerCase();
    if (method == 'post') {

        return instance.post(url, data)
    } else if (method == 'get') {

        return instance.get(url, data)
    } else if (method == 'delete') {

        return instance.delete(url, data)
    } else if (method == 'put') {

        return instance.put(url, data)
    } else {

        console.error('未知的method' + method)
        return false
    }
}